import { render, staticRenderFns } from "./workRecordSubmenu.vue?vue&type=template&id=552fccc0&"
import script from "./workRecordSubmenu.vue?vue&type=script&lang=ts&"
export * from "./workRecordSubmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports